<template>
  <div class="OperateLog">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div
          style="width:100vw"
        >
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">運轉日誌</span>
              </b-col>

              <b-col cols="12" class="mx-0" style="margin-top: 2rem">
                <b-row>
                  <commonQueryIoT />
                </b-row>
              </b-col>

              <b-col cols="12" style="margin-top: 2rem">
                <queryResult />
              </b-col>

              <!-- <stackBar style="margin-top: 2rem; padding: 0px 15px" /> -->
              <stackBar
                style="margin-top: 2rem; padding: 0px 15px"
                :stacksBarClass="stacksBarClass"
                :stacksBarMaxValue="stacksBarMaxValue"
                :stacksData="
                  stacksBar_data != '' ? stacksBar_data : stacksBarDefault
                "
                :stacksSize="'normal'"
              />

              <!-- <singleChart class="text-left" style="margin-top: 2rem" /> -->

              <b-col cols="12" class="text-right">
                <exportCsv />
              </b-col>

              <b-col
                cols="12"
                class="text-right mx-0 px-0"
                style="margin-top: 0.6rem"
              >
                <operateLogData class="text-left" />
              </b-col>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import stackBar from "@/components/stackBar.vue";
import queryResult from "@/components/queryResult.vue";
import operateLogData from "@/components/operateLogData.vue";
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import exportCsv from "@/components/exportCsv.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OperateLog",
  data() {
    return {
      operateLogDataFields: [
        {
          key: "status",
          label: "狀態",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "alarmCode",
          label: "代碼",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "alarmDetail",
          label: "代碼說明",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "startTime",
          label: "開始時間",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "endTime",
          label: "結束時間",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
        {
          key: "durationTime",
          label: "持續時間",
          sortable: true,
          class: "font-family-dfyuanstd-w5",
        },
      ],
      stacksBar_data: "",
      stacksBarDefault: {
        default: [
          {
            status: null,
            endTime: "2021-04-08 08:00:29",
            alarmDetail: "",
            startTime: "2021-04-08 08:00:00",
            duration_number: 0,
          },
        ],
      },
    };
  },
  created: function () {
    this.change_selectPage("operatelog");
    // this.getSelectOption();
    this.change_selectPageName(this.pageName.operatelog);
    this.setCommonQueryData();
    this.setQueryInput();
    this.set_operateLogDataFields(this.operateLogDataFields);
    this.set_operateLogTableStyle();
  },
  mounted: function () {
    let vm = this;
    vm.resetExportCsv();
    vm.setExportDataTitle();
  },
  components: {
    stackBar,
    queryResult,
    operateLogData,
    commonQueryIoT,
    exportCsv,
  },
  watch: {
    mainQueryResponse: {
      handler() {
        let vm = this;
        if (
          vm.mainQueryResponse == "查無資料" ||
          vm.mainQueryResponse == "時間尚未選擇"
        ) {
          vm.clear_operateLogDataItem();
          vm.set_exportData([]);
          vm.clear_queryResultItem();
          return;
        }
        var itemsarray = [];
        let test = 0;
        for (var i = 0; i < vm.mainQueryResponse.length; i++) {
          for (var j = 0; j < vm.mainQueryResponse[i].total_data.length; j++) {
            let total_data = vm.mainQueryResponse[i].total_data;
            var itemsobj = {};
            itemsobj["status"] = total_data[j]["status"];
            itemsobj["alarmCode"] = total_data[j]["alarmCode"];
            itemsobj["alarmDetail"] = total_data[j]["alarmDetail"];
            itemsobj["startTime"] = total_data[j]["startTime"];
            itemsobj["endTime"] = total_data[j]["endTime"];
            itemsobj["durationTime"] = total_data[j]["durationTime"];
            // itemsobj["device_name"] = total_data[j]["device_name"];
            // itemsobj["place_item"] = total_data[j]["place_item"];
            // itemsobj["group_item"] = total_data[j]["group_item"];
            // itemsobj["class_item"] = total_data[j]["class_item"];
            itemsarray.push(itemsobj);
          }
          console.log(itemsarray);
          vm.set_exportData(itemsarray);
          vm.set_operateLogDataItem(itemsarray);

          //堆疊圖
          vm.stacksBar_data = vm.mainQueryResponse[i].machine_data;

          vm.set_queryResultItem([
            {
              date: vm.mainQueryResponse[0].query_date[0].split(" ")[0],
              site: vm.mainQueryResponse[0].query_date[1],
              process: vm.mainQueryResponse[0].query_date[2],
              group: vm.mainQueryResponse[0].query_date[3],
              device: vm.mainQueryResponse[0].query_date[4],
            },
          ]);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
      mainQueryResponse: "commonqueryiot/get_queryResponse",
      operateLogDataFields: "operateLogData/get_operateLogDataFields",
      stacksBarClass: "stackBar/get_stacksBarClass",
      stacksBarMaxValue: "stackBar/get_stacksBarMaxValue",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_processOption: "commonqueryiot/set_processOption",
      set_deviceOption: "commonqueryiot/set_deviceOption",
      set_groupOption: "commonqueryiot/set_groupOption",
      set_queryResultItem: "queryResult/set_queryResultItem",
      clear_queryResultItem: "queryResult/clear_queryResultItem",
      set_operateLogDataFields: "operateLogData/set_operateLogDataFields",
      set_operateLogTableStyle: "operateLogData/set_operateLogTableStyle",
      set_operateLogDataItem: "operateLogData/set_operateLogDataItem",
      clear_operateLogDataItem: "operateLogData/clear_operateLogDataItem",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("OperateLog");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        endTime: false,
        deviceCode: true,
        process: true,
      });
      vm.set_selectTagCheck({
        startTime: true,
        endTime: false,
        process: true,
        deviceCode: true,
        productCode: false,
        workCode: false,
      });
    },
    getSelectOption() {
      let vm = this;
      var params = {};
      params["vuePage"] = "selectoption";
      params["methods"] = "GET";
      params["whichFunction"] = "SelectOption";
      console.log(params);
      vm.axiosAction(params).then(() => {
        var result = vm.axiosResult;
         if (result["Response"] == "ok") {
          vm.set_processOption(result.QueryTableData.process);
          vm.set_groupOption(result.QueryTableData.group);
          vm.set_deviceOption(result.QueryTableData.device);
        }
      });
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      vm.operateLogDataFields.forEach((data) => {
        exportDataTitle.push(data.label);
      });
      vm.set_exportDataTitle(exportDataTitle);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    this.clear_queryResultItem();
    this.clear_operateLogDataItem();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/views/OperateLog.vue